import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const recipeAdminLibraryManagerAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.AdminPanel,
}
